<app-customer [padding]="_testimonials" [title]="_title_1"></app-customer>
<app-testimonials *ngIf="_testimonials" [title]="_title_2" [subtitle]="_subtitle"></app-testimonials>
